import { render, staticRenderFns } from "./Dvizhenie_sklad.vue?vue&type=template&id=3a9896dc&scoped=true&"
import script from "./Dvizhenie_sklad.vue?vue&type=script&lang=js&"
export * from "./Dvizhenie_sklad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9896dc",
  null
  
)

export default component.exports